import type { IconPackId } from 'dragonmouse-shared/interfaces';

// Curated icon names per pack for autocomplete in ComponentPage.
// Each pack uses its own naming convention (see ICON_PACKS usage in shared/constants.ts).

const phosphor: string[] = [
	'house', 'user', 'heart', 'star', 'magnifying-glass', 'lock', 'folder', 'calendar',
	'envelope', 'bell', 'gear', 'trash', 'check', 'x', 'plus', 'minus', 'arrow-left', 'arrow-right',
	'arrow-up', 'arrow-down', 'chevron-left', 'chevron-right', 'chevron-up', 'chevron-down',
	'menu', 'dots-three', 'camera', 'image', 'file', 'link', 'share', 'download', 'upload',
	'search', 'settings', 'home', 'person', 'users', 'bookmark', 'heart', 'star-half',
	'bell-ringing', 'envelope-open', 'folder-open', 'lock-open', 'key', 'shield', 'warning',
	'info', 'question', 'check-circle', 'x-circle', 'plus-circle', 'minus-circle',
	'arrow-circle-left', 'arrow-circle-right', 'arrow-circle-up', 'arrow-circle-down',
	'caret-left', 'caret-right', 'caret-up', 'caret-down', 'sign-in', 'sign-out',
	'pencil', 'pencil-simple', 'note-pencil', 'eraser', 'highlighter', 'pen', 'pen-nib',
	'copy', 'clipboard', 'scissors', 'paperclip', 'link-simple', 'link-break',
	'eye', 'eye-slash', 'eye-closed', 'camera-slash', 'image-broken',
	'phone', 'phone-call', 'phone-slash', 'phone-outgoing', 'phone-incoming',
	'chat', 'chat-circle', 'chat-dots', 'chat-text', 'chats', 'envelope-simple',
	'calendar-blank', 'calendar-check', 'calendar-plus', 'calendar-minus', 'clock',
	'timer', 'hourglass', 'watch', 'alarm',
	'map-pin', 'map-pin-simple', 'compass', 'navigation-arrow', 'globe', 'globe-simple',
	'building', 'buildings', 'house-simple', 'house-line', 'storefront', 'warehouse',
	'car', 'bus', 'bicycle', 'airplane', 'rocket', 'train', 'ship', 'anchor',
	'briefcase', 'suitcase', 'shopping-bag', 'shopping-cart', 'credit-card', 'wallet',
	'money', 'coins', 'currency-dollar', 'bank', 'receipt', 'chart-line', 'chart-bar',
	'chart-pie', 'trend-up', 'trend-down', 'calculator', 'percent',
	'monitor', 'laptop', 'desktop', 'device-mobile', 'device-tablet', 'television',
	'cpu', 'hard-drive', 'wifi-high', 'wifi-slash', 'bluetooth', 'battery-full', 'battery-empty',
	'lightbulb', 'flashlight', 'moon', 'sun', 'cloud', 'cloud-rain', 'cloud-sun',
	'umbrella', 'snowflake', 'thermometer', 'fire', 'drop', 'leaf', 'tree', 'flower',
	'heart-break', 'smiley', 'smiley-wink', 'smiley-sad', 'smiley-meh',
	'thumbs-up', 'thumbs-down', 'hand-thumbs-up', 'hand-thumbs-down',
	'book', 'book-open', 'bookmark', 'bookmarks', 'newspaper', 'file', 'file-text',
	'file-pdf', 'file-image', 'folder', 'folder-open', 'folders', 'archive',
	'database', 'hard-drives', 'cloud-arrow-up', 'cloud-arrow-down',
	'play', 'pause', 'stop', 'skip-back', 'skip-forward', 'rewind', 'fast-forward',
	'microphone', 'microphone-slash', 'speaker-high', 'speaker-slash', 'headphones',
	'video-camera', 'video-camera-slash', 'camera', 'camera-plus', 'image', 'images',
	'film-strip', 'music-notes', 'radio', 'broadcast',
	'list', 'list-bullets', 'list-numbers', 'list-checks', 'list-magnifying-glass',
	'rows', 'squares-four', 'grid-four', 'layout', 'sidebar', 'columns',
	'table', 'browsers', 'browser', 'app-window', 'code', 'terminal',
	'bug', 'code-simple', 'brackets-curly', 'brackets-square', 'function',
	'git-branch', 'git-commit', 'git-merge', 'git-pull-request', 'github-logo',
	'magnifying-glass-plus', 'magnifying-glass-minus', 'funnel', 'sliders',
	'sort-ascending', 'sort-descending', 'arrows-vertical', 'arrows-horizontal',
	'filter', 'funnel-simple', 'caret-up-down', 'caret-double-up', 'caret-double-down',
	'arrow-up', 'arrow-down', 'arrow-left', 'arrow-right',
	'arrow-up-left', 'arrow-up-right', 'arrow-down-left', 'arrow-down-right',
	'arrow-clockwise', 'arrow-counter-clockwise', 'arrows-clockwise', 'arrows-counter-clockwise',
	'repeat', 'shuffle', 'shuffle-simple', 'swap', 'arrows-left-right',
	'export', 'import', 'download', 'upload', 'share', 'share-network', 'share-fat',
	'link', 'link-simple', 'link-simple-break', 'paper-plane', 'paper-plane-right',
	'at', 'hash', 'tag', 'tag-simple', 'bookmark-simple',
	'circle', 'square', 'triangle', 'hexagon', 'octagon', 'pentagon',
	'caret-circle-down', 'caret-circle-up', 'caret-circle-left', 'caret-circle-right',
	'prohibit', 'warning', 'warning-circle', 'warning-octagon', 'info',
	'question', 'question-mark', 'exclamation-mark', 'spinner', 'circle-notch',
	'check-fat', 'plus-minus', 'equals', 'not-equals', 'divide', 'percent',
	'infinity', 'sigma', 'pi', 'function', 'math-operations',
	'paint-brush', 'paint-bucket', 'palette', 'eyedropper', 'highlighter-circle',
	'crop', 'scissors', 'eraser', 'pen-nib-straight', 'scribble-loop',
	'user-plus', 'user-minus', 'user-circle-plus', 'user-circle-minus',
	'users-three', 'users-four', 'user-rectangle', 'user-square', 'user-focus',
	'identification-card', 'identification-badge', 'fingerprint', 'key',
	'lock-simple', 'lock-simple-open', 'shield-check', 'shield-warning', 'shield-plus',
	'hand', 'hand-pointing', 'hand-fist', 'hand-waving', 'handshake',
	'paw-print', 'cat', 'dog', 'bird', 'fish', 'bug', 'butterfly', 'flower',
	'coffee', 'wine', 'beer-bottle', 'pizza', 'hamburger', 'cake', 'ice-cream',
	'apple-logo', 'carrot', 'leaf', 'tree-evergreen', 'tree-palm', 'cactus',
	'gift', 'party-popper', 'confetti', 'balloon', 'cake', 'crown',
	'medal', 'trophy', 'star-four', 'certificate', 'award',
	'phone', 'envelope', 'chat-circle-dots', 'megaphone', 'bell-simple',
	'calendar-dot', 'calendar-dots', 'clock-countdown', 'timer', 'hourglass-simple',
	'map-pin', 'compass', 'globe-stand', 'car', 'bus', 'bicycle', 'train-simple',
	'rocket-launch', 'airplane-takeoff', 'ship', 'anchor-simple',
	'briefcase', 'suitcase-simple', 'shopping-cart-simple', 'credit-card',
	'receipt', 'chart-line-up', 'chart-pie-slice', 'trend-up', 'calculator',
	'monitor-play', 'laptop', 'device-mobile', 'tablet', 'television-simple',
	'cpu', 'hard-drives', 'wifi-medium', 'bluetooth-connected', 'battery-charging',
	'lightbulb-filament', 'flashlight', 'moon-stars', 'sun-horizon', 'cloud-fog',
	'umbrella-simple', 'snowflake', 'thermometer-simple', 'fire-simple',
	'heart-straight', 'smiley-blank', 'smiley-nervous', 'smiley-angry',
	'book-open-text', 'bookmark-simple', 'newspaper-clipping', 'file-dashed',
	'folder-simple', 'folder-simple-plus', 'archive-box', 'database',
	'play-circle', 'pause-circle', 'stop-circle', 'skip-back-circle', 'skip-forward-circle',
	'microphone-stage', 'speaker-simple-high', 'speaker-simple-slash', 'headset',
	'video', 'camera-rotate', 'image-square', 'images-square', 'film-reel',
	'list-dashes', 'list-plus', 'squares-four', 'layout-dashboard', 'sidebar-simple',
	'layout', 'columns-plus-left', 'table', 'browser-chrome', 'code-block',
	'bug-droid', 'brackets-round', 'terminal-window', 'git-fork', 'gitlab-logo',
];

const lucide: string[] = [
	'home', 'user', 'heart', 'star', 'search', 'lock', 'folder', 'calendar',
	'mail', 'bell', 'settings', 'trash', 'check', 'x', 'plus', 'minus', 'arrow-left', 'arrow-right',
	'arrow-up', 'arrow-down', 'chevron-left', 'chevron-right', 'chevron-up', 'chevron-down',
	'menu', 'more-horizontal', 'camera', 'image', 'file', 'link', 'share', 'download', 'upload',
	'settings', 'users', 'bookmark', 'star-half', 'bell-ring', 'mail-open', 'folder-open',
	'unlock', 'key', 'shield', 'alert-triangle', 'info', 'help-circle', 'check-circle', 'x-circle',
	'plus-circle', 'minus-circle', 'arrow-left-circle', 'arrow-right-circle', 'arrow-up-circle',
	'arrow-down-circle', 'chevrons-left', 'chevrons-right', 'chevrons-up', 'chevrons-down',
	'log-in', 'log-out', 'pencil', 'edit', 'edit-2', 'edit-3', 'eraser', 'highlighter', 'pen-tool',
	'copy', 'clipboard', 'scissors', 'paperclip', 'link-2', 'unlink',
	'eye', 'eye-off', 'camera-off', 'image-off', 'phone', 'phone-call', 'phone-off', 'phone-outgoing',
	'phone-incoming', 'message-circle', 'message-square', 'messages-square', 'send',
	'calendar-days', 'calendar-check', 'calendar-plus', 'calendar-minus', 'clock', 'timer',
	'hourglass', 'watch', 'alarm-clock', 'map-pin', 'map', 'compass', 'navigation', 'globe',
	'building', 'building-2', 'home', 'store', 'warehouse', 'car', 'bus', 'bike', 'plane',
	'rocket', 'train', 'ship', 'anchor', 'briefcase', 'luggage', 'shopping-bag', 'shopping-cart',
	'credit-card', 'wallet', 'dollar-sign', 'coins', 'landmark', 'receipt', 'trending-up',
	'trending-down', 'line-chart', 'bar-chart', 'pie-chart', 'calculator', 'percent',
	'monitor', 'laptop', 'desktop', 'smartphone', 'tablet', 'tv', 'cpu', 'hard-drive',
	'wifi', 'wifi-off', 'bluetooth', 'battery', 'battery-charging', 'lightbulb', 'flashlight',
	'moon', 'sun', 'cloud', 'cloud-rain', 'cloud-sun', 'umbrella', 'snowflake', 'thermometer',
	'flame', 'droplet', 'leaf', 'tree-pine', 'tree-deciduous', 'flower', 'flower-2',
	'heart', 'heart-crack', 'smile', 'laugh', 'frown', 'meh', 'thumbs-up', 'thumbs-down',
	'book', 'book-open', 'bookmark', 'bookmark-check', 'newspaper', 'file', 'file-text',
	'file-type', 'folder', 'folder-open', 'folders', 'archive', 'database', 'server',
	'cloud-upload', 'cloud-download', 'play', 'pause', 'stop-circle', 'skip-back', 'skip-forward',
	'rewind', 'fast-forward', 'mic', 'mic-off', 'volume-2', 'volume-x', 'headphones',
	'video', 'video-off', 'camera', 'image', 'images', 'film', 'music', 'music-2', 'radio',
	'list', 'list-ordered', 'list-checks', 'layout-grid', 'layout', 'sidebar', 'columns',
	'table', 'layout-dashboard', 'browser', 'code', 'terminal', 'bug', 'braces', 'brackets',
	'git-branch', 'git-commit', 'git-merge', 'git-pull-request', 'github', 'search', 'filter',
	'sliders-horizontal', 'arrow-up-down', 'arrow-left-right', 'rotate-cw', 'rotate-ccw',
	'repeat', 'shuffle', 'move', 'arrow-left-right', 'download', 'upload', 'share-2',
	'link', 'unlink', 'send', 'at-sign', 'hash', 'tag', 'bookmark-plus',
	'circle', 'square', 'triangle', 'hexagon', 'octagon', 'ban', 'alert-triangle', 'alert-circle',
	'info', 'help-circle', 'circle-help', 'loader', 'loader-2', 'check', 'plus', 'minus',
	'divide', 'percent', 'infinity', 'sigma', 'function', 'equal', 'not-equal',
	'paintbrush', 'palette', 'pipette', 'crop', 'scissors', 'eraser', 'pen-tool',
	'user-plus', 'user-minus', 'users', 'user-circle', 'id-card', 'fingerprint', 'key',
	'lock-open', 'shield', 'shield-check', 'shield-alert', 'shield-plus', 'hand', 'hand-metal',
	'paw-print', 'cat', 'dog', 'bird', 'fish', 'bug', 'butterfly', 'flower', 'flower-2',
	'coffee', 'wine', 'beer', 'pizza', 'sandwich', 'cake', 'ice-cream', 'apple', 'carrot',
	'leaf', 'tree-pine', 'gift', 'party-popper', 'balloon', 'crown', 'medal', 'trophy',
	'phone', 'mail', 'message-circle', 'megaphone', 'bell', 'calendar', 'clock', 'timer',
	'map-pin', 'compass', 'globe', 'car', 'bus', 'bike', 'plane', 'rocket', 'train', 'ship',
	'briefcase', 'shopping-bag', 'credit-card', 'receipt', 'trending-up', 'calculator',
	'monitor', 'laptop', 'smartphone', 'cpu', 'wifi', 'battery', 'lightbulb', 'moon', 'sun',
	'cloud', 'umbrella', 'thermometer', 'flame', 'heart', 'smile', 'thumbs-up', 'book',
	'file', 'folder', 'archive', 'play', 'mic', 'video', 'camera', 'list', 'layout', 'code',
	'git-branch', 'search', 'filter', 'download', 'share-2', 'link', 'circle', 'alert-triangle',
	'user-plus', 'key', 'shield', 'hand', 'gift', 'phone', 'map-pin', 'car', 'briefcase',
];

const materialSymbols: string[] = [
	'home', 'person', 'favorite', 'star', 'search', 'lock', 'folder', 'event',
	'mail', 'notifications', 'settings', 'delete', 'check', 'close', 'add', 'remove',
	'arrow_back', 'arrow_forward', 'arrow_upward', 'arrow_downward', 'chevron_left', 'chevron_right',
	'chevron_up', 'chevron_down', 'menu', 'more_horiz', 'photo_camera', 'image', 'description',
	'link', 'share', 'download', 'upload', 'person', 'people', 'bookmark', 'star_half',
	'notifications_active', 'mail_outline', 'folder_open', 'lock_open', 'key', 'shield',
	'warning', 'info', 'help', 'check_circle', 'cancel', 'add_circle', 'remove_circle',
	'arrow_back_ios', 'arrow_forward_ios', 'login', 'logout', 'edit', 'edit_note', 'brush',
	'content_copy', 'content_paste', 'content_cut', 'attach_file', 'link_off',
	'visibility', 'visibility_off', 'photo_camera', 'image_not_supported', 'phone', 'phone_enabled',
	'phone_disabled', 'chat', 'chat_bubble', 'send', 'email', 'event', 'schedule', 'access_time',
	'alarm', 'location_on', 'place', 'explore', 'public', 'apartment', 'store', 'warehouse',
	'directions_car', 'directions_bus', 'directions_bike', 'flight', 'rocket_launch',
	'directions_transit', 'anchor', 'work', 'luggage', 'shopping_bag', 'shopping_cart',
	'credit_card', 'account_balance_wallet', 'payments', 'savings', 'receipt', 'trending_up',
	'trending_down', 'show_chart', 'bar_chart', 'pie_chart', 'calculate', 'percent',
	'computer', 'laptop', 'desktop_windows', 'smartphone', 'tablet', 'tv', 'memory',
	'wifi', 'wifi_off', 'bluetooth', 'battery_full', 'battery_charging_full',
	'lightbulb', 'flashlight_on', 'dark_mode', 'light_mode', 'cloud', 'cloud_queue',
	'water_drop', 'ac_unit', 'thermostat', 'local_fire_department', 'water_drop',
	'eco', 'park', 'forest', 'local_florist', 'favorite', 'sentiment_satisfied',
	'sentiment_dissatisfied', 'thumb_up', 'thumb_down', 'menu_book', 'menu_book',
	'bookmark', 'article', 'folder', 'folder_open', 'archive', 'storage', 'cloud_upload',
	'cloud_download', 'play_arrow', 'pause', 'stop', 'skip_previous', 'skip_next',
	'replay', 'fast_forward', 'mic', 'mic_off', 'volume_up', 'volume_off', 'headphones',
	'videocam', 'videocam_off', 'photo_camera', 'image', 'perm_media', 'movie', 'music_note',
	'radio', 'list', 'format_list_bulleted', 'format_list_numbered', 'checklist', 'grid_view',
	'dashboard', 'view_sidebar', 'table_chart', 'web', 'code', 'terminal', 'bug_report',
	'integration_instructions', 'account_tree', 'merge_type', 'pull_request', 'github',
	'search', 'filter_list', 'tune', 'swap_vert', 'swap_horiz', 'refresh', 'sync',
	'repeat', 'shuffle', 'swap_horiz', 'file_download', 'file_upload', 'share',
	'link', 'link_off', 'send', 'alternate_email', 'tag', 'bookmark_add',
	'circle', 'square', 'change_history', 'hexagon', 'block', 'report', 'report_problem',
	'info', 'help_outline', 'progress_activity', 'check_circle', 'add', 'remove',
	'percent', 'functions', 'calculate', 'equal', 'not_equal', 'format_paint', 'palette',
	'format_color_fill', 'crop', 'content_cut', 'brush', 'person_add', 'person_remove',
	'group', 'badge', 'fingerprint', 'key', 'lock_open', 'shield', 'security', 'shield_with_heart',
	'back_hand', 'front_hand', 'pets', 'cruelty_free', 'local_florist', 'emoji_emotions',
	'coffee', 'wine_bar', 'lunch_dining', 'cake', 'icecream', 'apple', 'eco', 'park',
	'card_giftcard', 'celebration', 'balloon', 'local_dining', 'military_tech', 'emoji_events',
	'workspace_premium', 'phone', 'mail', 'chat', 'campaign', 'notifications',
	'event', 'schedule', 'access_time', 'location_on', 'explore', 'directions_car',
	'rocket_launch', 'work', 'shopping_bag', 'credit_card', 'receipt', 'trending_up',
	'computer', 'smartphone', 'memory', 'wifi', 'battery_charging_full', 'lightbulb',
	'dark_mode', 'cloud', 'thermostat', 'favorite', 'sentiment_satisfied', 'menu_book',
	'folder', 'archive', 'play_arrow', 'mic', 'videocam', 'photo_camera', 'list',
	'dashboard', 'code', 'search', 'file_download', 'share', 'link', 'circle', 'report',
	'person_add', 'key', 'shield', 'back_hand', 'card_giftcard', 'phone', 'location_on',
];

const fontAwesome: string[] = [
	'house', 'user', 'heart', 'star', 'magnifying-glass', 'lock', 'folder', 'calendar',
	'envelope', 'bell', 'gear', 'trash', 'check', 'xmark', 'plus', 'minus', 'arrow-left', 'arrow-right',
	'arrow-up', 'arrow-down', 'chevron-left', 'chevron-right', 'chevron-up', 'chevron-down',
	'bars', 'ellipsis', 'camera', 'image', 'file', 'link', 'share', 'download', 'upload',
	'cog', 'users', 'bookmark', 'star-half-stroke', 'bell', 'envelope-open', 'folder-open',
	'lock-open', 'key', 'shield', 'triangle-exclamation', 'circle-info', 'circle-question',
	'circle-check', 'circle-xmark', 'circle-plus', 'circle-minus', 'arrow-left', 'arrow-right',
	'arrow-up', 'arrow-down', 'right-from-bracket', 'right-to-bracket', 'pen', 'pen-to-square',
	'eraser', 'highlighter', 'pen-nib', 'copy', 'clipboard', 'scissors', 'paperclip', 'link',
	'unlink', 'eye', 'eye-slash', 'camera', 'image', 'phone', 'phone-flip', 'phone-slash',
	'phone-arrow-up-right', 'phone-arrow-down-left', 'comment', 'comments', 'message', 'paper-plane',
	'calendar-days', 'calendar-check', 'calendar-plus', 'calendar-minus', 'clock', 'timer',
	'hourglass-half', 'location-dot', 'map-location-dot', 'compass', 'globe', 'building',
	'building-columns', 'house', 'store', 'warehouse', 'car', 'bus', 'bicycle', 'plane',
	'rocket', 'train', 'ship', 'anchor', 'briefcase', 'suitcase', 'bag-shopping', 'cart-shopping',
	'credit-card', 'wallet', 'dollar-sign', 'coins', 'landmark', 'receipt', 'chart-line',
	'chart-simple', 'chart-pie', 'calculator', 'percent', 'laptop', 'desktop', 'mobile',
	'tablet-screen-button', 'tv', 'microchip', 'hard-drive', 'wifi', 'bluetooth', 'battery-full',
	'battery-half', 'lightbulb', 'lightbulb', 'moon', 'sun', 'cloud', 'cloud-rain',
	'umbrella', 'snowflake', 'temperature-half', 'fire', 'droplet', 'leaf', 'tree', 'flower',
	'heart', 'heart-crack', 'face-smile', 'face-laugh', 'face-frown', 'face-meh',
	'thumbs-up', 'thumbs-down', 'book', 'book-open', 'bookmark', 'newspaper', 'file',
	'file-lines', 'folder', 'folder-open', 'boxes-stacked', 'database', 'server',
	'cloud-arrow-up', 'cloud-arrow-down', 'play', 'pause', 'stop', 'backward', 'forward',
	'rotate-left', 'forward-fast', 'microphone', 'microphone-slash', 'volume-high', 'volume-xmark',
	'headphones', 'video', 'video-slash', 'camera', 'image', 'images', 'film', 'music',
	'list', 'list-ol', 'list-check', 'grid', 'layout', 'bars-staggered', 'table-columns',
	'table', 'chrome', 'code', 'terminal', 'bug', 'braces', 'code-branch', 'code-merge',
	'code-pull-request', 'github', 'magnifying-glass', 'filter', 'sliders', 'arrows-up-down',
	'arrows-left-right', 'rotate', 'rotate-right', 'repeat', 'shuffle', 'arrows-rotate',
	'file-export', 'file-import', 'download', 'upload', 'share-nodes', 'link', 'unlink',
	'at', 'hashtag', 'tag', 'bookmark', 'circle', 'square', 'triangle-exclamation',
	'ban', 'circle-exclamation', 'circle-info', 'circle-question', 'spinner', 'circle-check',
	'plus', 'minus', 'divide', 'percent', 'infinity', 'pen', 'palette', 'droplet', 'crop',
	'scissors', 'eraser', 'user-plus', 'user-minus', 'users', 'id-card', 'fingerprint',
	'key', 'lock-open', 'shield', 'shield-halved', 'shield-heart', 'hand', 'hand-fist',
	'paw', 'cat', 'dog', 'bird', 'fish', 'bug', 'seedling', 'flower', 'mug-saucer', 'wine-glass',
	'beer-mug-empty', 'pizza-slice', 'burger', 'cake-candles', 'ice-cream', 'apple-whole',
	'carrot', 'leaf', 'tree', 'gift', 'party-horn', 'crown', 'medal', 'trophy', 'star',
	'phone', 'envelope', 'comment', 'bullhorn', 'bell', 'calendar', 'clock', 'hourglass-half',
	'location-dot', 'compass', 'globe', 'car', 'bus', 'bicycle', 'plane', 'rocket', 'train',
	'briefcase', 'bag-shopping', 'credit-card', 'receipt', 'chart-line', 'calculator',
	'laptop', 'mobile', 'microchip', 'wifi', 'battery-full', 'lightbulb', 'moon', 'sun',
	'cloud', 'umbrella', 'temperature-half', 'fire', 'heart', 'face-smile', 'thumbs-up',
	'book', 'file', 'folder', 'archive', 'play', 'microphone', 'video', 'camera', 'list',
	'layout', 'code', 'code-branch', 'magnifying-glass', 'download', 'share-nodes', 'link',
	'circle', 'triangle-exclamation', 'user-plus', 'key', 'shield', 'hand', 'gift', 'phone',
];

export const ICON_NAMES: Record<IconPackId, string[]> = {
	'material-symbols': materialSymbols,
	phosphor,
	lucide,
	'font-awesome': fontAwesome,
};
